import { Badge } from "@/app/admin/_common/ui/badge";
import { SHOW_STATUS_LABEL, SHOW_STATUS_DOT_CLASSES, ShowStatus } from "./showStatus";

const STATUS_BADGE_CLASSES: Record<ShowStatus, string> = {
  "on-sale": "border-emerald-200 bg-emerald-50 text-emerald-700",
  "almost-sold-out": "border-amber-200 bg-amber-50 text-amber-700",
  "sold-out": "border-red-200 bg-red-50 text-red-600",
  draft: "border-slate-200 bg-slate-50 text-slate-600",
  past: "border-border bg-transparent text-muted-foreground/70",
};

export default function StatusBadge({ status }: { status: ShowStatus }) {
  return (
    <Badge
      variant="outline"
      className={`gap-1.5 whitespace-nowrap rounded-[7px] font-normal ${STATUS_BADGE_CLASSES[status]}`}
    >
      <span className={`size-1.5 flex-none rounded-full ${SHOW_STATUS_DOT_CLASSES[status]}`} />
      {SHOW_STATUS_LABEL[status]}
    </Badge>
  );
}
